export default "__VITE_ASSET__BxnSXjSP__"